import { Input as InputComponent } from '@components-deprecated'

import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { CompanySelector as CompanySelectorComponent } from '@modules-deprecated/app'

export const Input = styled(InputComponent)`
  margin-bottom: ${Spacing.S16};
`

export const CompanySelector = styled(CompanySelectorComponent)`
  margin-bottom: ${Spacing.S16};
`

export const DetailsSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const SwitcherTitle = styled.span`
  margin-right: ${Spacing.S8};
`

export const ButtonWrapper = styled.div`
  margin-top: ${Spacing.S16};
`
